import { Typography } from "antd";
import { useState } from "react";

const AeroflexProducts = () => {
  const [activeSection, setActiveSection] = useState("section1");

  const toggleSection = (sectionName) => {
    setActiveSection(sectionName);
  };

  return (
    <div className="max-w-screen text-left">
      <div className="relative hidden w-screen bg-center bg-cover lg:block max-w-screen max-w-full">
        <img src="/assets/images/aeroflex-tab/aeroflexBG.png" alt="image-" />
        <div className="absolute top-0 flex items-center justify-between w-full h-full">
          <div className="flex flex-col items-start justify-between w-1/3 gap-4 p-8 tab pl-36">
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "section1" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("section1")}
            >
              Thermal Insulation
            </button>
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "acoustic" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("acoustic")}
            >
              Acoustic Insulation
            </button>
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "tapes" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("tapes")}
            >
              Tapes & Adhesives
            </button>
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "granule" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("granule")}
            >
              Colored Granule
            </button>
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "mat" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("mat")}
            >
              Door Mat
            </button>
          </div>
          <div className="w-2/3 h-full max-w-screen">
            <div
              className={`h-full sectionAero ${
                activeSection === "section1" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div
                  className="flex items-center justify-end w-2/3 h-full px-4 py-16 "
                  style={{ justifyContent: "end" }}
                >
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Aeroflex Products
                    </Typography.Title>
                    <h1 className="text-left text-[#343A40] font-semibold">
                      Thermal Insulation
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973] text-left">
                      ALP Aeroflex offers a diverse range of EPDM & NBR Thermal
                      insulation sheets and tubes for insulation requirements
                      across industries. The Closed Cell Insulation Foam Sheets
                      & Tubes are available with and without Lamination. With a
                      variety of different features, our range of Thermal
                      insulation has low Thermal Conductivity and high Water
                      Vapor diffusion Resistance.
                    </p>
                  </div>
                </div>
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/aeroflex-tab/thermal_Insulation.png"
                    alt="EPDM Profiles"
                  />
                </div>
              </div>
            </div>
            <div
              className={`h-full sectionAero ${
                activeSection === "acoustic" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div
                  className="flex items-center justify-end w-2/3 h-full px-4 py-16 "
                  style={{ justifyContent: "end" }}
                >
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Aeroflex Products
                    </Typography.Title>
                    <h1 className="text-base text-[#343A40] font-semibold">
                      Acoustic Insulation
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973]">
                      ALP Aeroflex's Open Cell NBR Acoustic solutions are
                      perfect for effective absorption and barrier for sound
                      across a broad range of frequencies. Our product offering
                      is EPA Approved for being Anti-Microbial and complies with
                      Fire Safety Class 1 & 0. The light weight material offers
                      Anti-Bacterial and Anti-Fungal properties.
                    </p>
                  </div>
                </div>
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/aeroflex-tab/acoustic.png"
                    alt="EPDM Profiles"
                  />
                </div>
              </div>
            </div>
            <div
              className={`h-full sectionAero ${
                activeSection === "tapes" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div
                  className="flex items-center justify-end w-2/3 h-full px-4 py-16 "
                  style={{ justifyContent: "end" }}
                >
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Aeroflex Products
                    </Typography.Title>
                    <h1 className="text-base text-[#343A40] font-semibold">
                      Tapes & Adhesives
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973]">
                      ALP Aeroflex offers a wide range of Self Adhesive
                      Insulation tapes with different laminations and other
                      accessories for different industrial requirements.
                    </p>
                  </div>
                </div>
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/aeroflex-tab/tapes.png"
                    alt="EPDM Profiles"
                  />
                </div>
              </div>
            </div>
            <div
              className={`h-full sectionAero ${
                activeSection === "granule" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div
                  className="flex items-center justify-end w-2/3 h-full px-4 py-16 "
                  style={{ justifyContent: "end" }}
                >
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Aeroflex Products
                    </Typography.Title>
                    <h1 className="text-base text-[#343A40] font-semibold">
                      Colored Granule
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973]">
                      Being a pioneer in Polymer products, ALP Overseas has an
                      expertise of over 35 years in developing long lasting &
                      functional EPDM profiles. Our seals and profiles for
                      automotive and Building and construction industries are
                      available in different colours, material extrusions and
                      with various application options to suit different
                      requirements.
                    </p>
                  </div>
                </div>
                <div className="flex items-end w-1/3 h-full">
                  <img src="/assets/images/epdm-tab.png" alt="EPDM Profiles" />
                </div>
              </div>
            </div>
            <div
              className={`h-full sectionAero ${
                activeSection === "mat" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div
                  className="flex items-center justify-end w-2/3 h-full px-4 py-16 "
                  style={{ justifyContent: "end" }}
                >
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Aeroflex Products
                    </Typography.Title>
                    <h1 className="text-base text-[#343A40] font-semibold">
                      Door Mat
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973]">
                      Being a pioneer in Polymer products, ALP Overseas has an
                      expertise of over 35 years in developing long lasting &
                      functional EPDM profiles. Our seals and profiles for
                      automotive and Building and construction industries are
                      available in different colours, material extrusions and
                      with various application options to suit different
                      requirements.
                    </p>
                  </div>
                </div>
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/aeroflex-tab/thermal_Insulation.png"
                    alt="EPDM Profiles"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Aeroflex Products Accordion */}
      <div className="block lg:hidden">
        <div className="flex items-center justify-center w-full mt-2 mb-6">
          <p className="w-10/12 text-[25px] font-semibold leading-6 text-center text-[#343A40]">
            Aeroflex Products
          </p>
        </div>

        <div className="flex flex-col items-center justify-center w-full gap-2 pb-4 accordion">
          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#0474B8] ${
                activeSection === "section1" ? "active" : ""
              }`}
              onClick={() => toggleSection("section1")}
            >
              <span>Thermal Insulation</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px]"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "section1" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat"
                style={{
                  backgroundImage:
                    "url('/assets/images/aeroflex-tab/mob-bga.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  Thermal Insulation
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  ALP Aeroflex offers a diverse range of EPDM & NBR Thermal
                  insulation sheets and tubes for insulation requirements across
                  industries. The Closed Cell Insulation Foam Sheets & Tubes are
                  available with and without Lamination. With a variety of
                  different features, our range of Thermal insulation has low
                  Thermal Conductivity and high Water Vapor diffusion
                  Resistance.
                </p>
              </div>
            </div>
          </div>

          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#0474B8] ${
                activeSection === "acoustic" ? "active" : ""
              }`}
              onClick={() => toggleSection("acoustic")}
            >
              <span>Acoustic Insulation</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px]"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "acoustic" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat bg-opacity-90"
                style={{
                  backgroundImage:
                    "url('/assets/images/aeroflex-tab/mob-bga.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  Accoustic Insulation
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  ALP Aeroflex's Open Cell NBR Acoustic solutions are perfect
                  for effective absorption and barrier for sound across a broad
                  range of frequencies. Our product offering is EPA Approved for
                  being Anti-Microbial and complies with Fire Safety Class 1 &
                  0. The light weight material offers Anti-Bacterial and
                  Anti-Fungal properties.
                </p>
              </div>
            </div>
          </div>

          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#0474B8] ${
                activeSection === "tapes" ? "active" : ""
              }`}
              onClick={() => toggleSection("tapes")}
            >
              <span>Tapes & Adhesives</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px]"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "tapes" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat bg-opacity-90"
                style={{
                  backgroundImage:
                    "url('/assets/images/aeroflex-tab/mob-bga.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  Tapes & Adhesives
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  ALP Aeroflex offers a wide range of Self Adhesive Insulation
                  tapes with different laminations and other accessories for
                  different industrial requirements.
                </p>
              </div>
            </div>
          </div>

          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#0474B8] ${
                activeSection === "granule" ? "active" : ""
              }`}
              onClick={() => toggleSection("granule")}
            >
              <span>Colored Granule</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px]"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "granule" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat bg-opacity-90"
                style={{
                  backgroundImage:
                    "url('/assets/images/aeroflex-tab/mob-bga.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  Colored Granule
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  Being a pioneer in Polymer products, ALP Overseas has an
                  expertise of over 35 years in developing long lasting &
                  functional EPDM profiles. Our seals and profiles for
                  automotive and Building and construction industries are
                  available in different colours, material extrusions and with
                  various application options to suit different requirements.
                </p>
              </div>
            </div>
          </div>

          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#0474B8] ${
                activeSection === "mat" ? "active" : ""
              }`}
              onClick={() => toggleSection("mat")}
            >
              <span>Door Mat</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px] text-white"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "mat" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat bg-opacity-90"
                style={{
                  backgroundImage:
                    "url('/assets/images/aeroflex-tab/mob-bga.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  Door Mat
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  Being a pioneer in Polymer products, ALP Overseas has an
                  expertise of over 35 years in developing long lasting &
                  functional EPDM profiles. Our seals and profiles for
                  automotive and Building and construction industries are
                  available in different colours, material extrusions and with
                  various application options to suit different requirements.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AeroflexProducts;
